import styled from 'styled-components';
import LazyLoadedImg from 'core/components/LazyLoadedImg';
import { StyleVars } from 'core/utils';

export const GalleryWrapper = styled.div`
	position: relative;
`;


export const BadgeImage = styled(LazyLoadedImg)`
	position: absolute;
	width: ${props => props.size || 80}px;
	height: ${props => props.size || 80}px;

	/*
	 * position below these:
	 * shareStyles__Links is z:9
	 */
	z-index: 2;

	/* just in case */
	max-width: 200px;
	max-height: 200px;

	/* on mobile show in corner */
	top: 0;
	right: 0;

	@media (min-width: ${StyleVars.screenSm}) {
		top: -20px;
		right: -20px;
	}
`;
